/**
 * Maps NEXT_PUBLIC_STAGE values to Flipt environment references.
 *
 * LOC/DEV/STG → 'dev'
 * PRD → 'live'
 */

type Stage = 'LOC' | 'DEV' | 'STG' | 'PRD';

const STAGE_TO_ENVIRONMENT: Record<Stage, string> = {
  LOC: 'dev',
  DEV: 'dev',
  STG: 'dev',
  PRD: 'live',
};

export function mapStageToEnvironment(stage?: string): string {
  if (!stage || !(stage in STAGE_TO_ENVIRONMENT)) {
    return 'dev';
  }
  return STAGE_TO_ENVIRONMENT[stage as Stage];
}
